import React, { useEffect, useState } from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import channelsData from '../../Data/marketingchannel.json'; 

const MarketingChannel = () => {
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    setChannels(channelsData);
  }, []);

  return (
    <Box 
      sx={{
        width: { xs: '90%', sm: '500px', md: '90%' }, 
        padding: 2, 
        borderRadius: 2, 
        boxShadow: 2, 
        backgroundColor: 'white', 
        overflow: 'hidden',
        marginLeft: { xs: 0, sm: 1 }, 
        marginTop: 2, 
        marginRight: { md: 0 }, 
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ fontSize: { xs: '1rem', sm: '1.125rem' }, fontWeight: 'bold' }}>
        Marketing Channel
      </Typography>
      {channels.map((channel) => (
        <Box key={channel.name} mb={1} sx={{ maxHeight: '40px' }}> 
          <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
            {channel.name}
          </Typography>
          <LinearProgress 
            variant="determinate" 
            value={channel.value} 
            sx={{ 
              height: 8, 
              borderRadius: 5, 
              marginBottom: 0.5, 
              backgroundColor: '#e0e0e0',  
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#3bb77e', 
              },
            }}
          />
          <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.75rem' }}>
            {channel.value}%
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default MarketingChannel;
